import { audioStatuses } from '@/utils'

export default {
  namespaced: true,

  state: {
    src: undefined,
    currentTime: undefined,
    duration: undefined,
    status: undefined,
    playerId: undefined
  },

  mutations: {
    setSrc(state, src) {
      state.src = src
    },
    setCurrentTime(state, currentTime) {
      state.currentTime = currentTime
    },
    setDuration(state, duration) {
      state.duration = duration
    },
    setStatus(state, status) {
      state.status = status
    },
    setPlayerId(state, playerId) {
      state.playerId = playerId
    }
  },

  actions: {
    setSrc({ commit, state }, src) {
      if (state.src === src) {
        switch (state.status) {
          case audioStatuses.play:
            commit('setStatus', audioStatuses.pause)
            break
          case audioStatuses.pause:
          case audioStatuses.ended:
          case audioStatuses.loading:
            commit('setStatus', audioStatuses.play)
            break
        }
      } else {
        commit('setSrc', src)
      }
    },
    setCurrentTime({ commit }, currentTime) {
      commit('setCurrentTime', currentTime)
    },
    setDuration({ commit }, duration) {
      commit('setDuration', duration)
    },
    setStatus({ commit }, status) {
      commit('setStatus', status)
    },
    setPlayerId({ commit }, playerId) {
      commit('setPlayerId', playerId)
    }
  },

  getters: {
    src: state => {
      return state.src
    },
    currentTime: state => {
      return state.currentTime
    },
    duration: state => {
      return state.duration
    },
    status: state => {
      return state.status
    },
    playerId: state => {
      return state.playerId
    }
  }
}
